import $ from 'jquery'
window.$ = $;
import * as material from 'materialize-css'; // don't let your IDE fool you, this import is IMPORTANT
import handlePage from './pages/pages';
import highlightActive from './nav/highlightActive';
import activateFirst from "./nav/activateFirst";
import {populateTitleInputsFromRichEditor} from './pages/admin';
import SessionTimeoutModalHandler from "./components/SessionTimeoutModalHandler";

(function () {
    highlightActive(window.location.href);
    activateFirst();
    activeFormSubmitters();
    activateSectionBuilder();
    sessionTimeoutModalInit();
    handlePage(window.location.pathname);
    multipleTabOpenAlertInit();
})();

function multipleTabOpenAlertInit() {
    const channel = new BroadcastChannel('tab');

    channel.postMessage('another-tab');
    // note that listener is added after posting the message

    channel.addEventListener('message', (msg) => {
      if (msg.data === 'another-tab') {
        // message received from 2nd tab
        alert('You have opened Assessment Services in another tab. Please make sure to only use the latest window so no data is lost');
      }
    });
}

function sessionTimeoutModalInit() {
    let sessionModalEl = $('#session_timeout_warning_modal');
    sessionModalEl.modal();
    if (sessionModalEl) {
        new SessionTimeoutModalHandler({
            modalEl: sessionModalEl,
            sessionCookieName: window.laravelSessionCookieName,
            cookieExpireMinutes: window.laravelSessionLifetime
        });
    }
}

function activeFormSubmitters() {
    $('.form-submit').click(evt => {
        const target = evt.currentTarget;
        const formId = target.getAttribute('data-form');

        if(formId) {
            document.getElementById(formId).submit();
        }
        else {
            const parent = target.parentNode;

            if(parent.tagName !== "FORM") {
                return console.error("Was not able to find form for .form-submit");
            }

            parent.submit();
        }
    });
}

function activateSectionBuilder() {
    $('button[id^="saveSections-"]').click(function(e){
        if (window.assessmentVersionInProgress && !window.confirm("Please proceed with caution. Minor fixes only")) {
            return;
        }
        const versionId = $(this).data('versionId');
        let allFormData = [];
        $('form[id^="section-"]').each(function(index){
            const sectionId = $(this).data('section');
            let sectionData = {};
            sectionData['id'] = sectionId;

            // only do this for the sections which are questions as they use rich text editor
            if ($(this).data('is-question') === true) {
                populateTitleInputsFromRichEditor(sectionId);
            }

            if (!$('#titleView-' + sectionId).val()) {
                $('#titleView-' + sectionId).css('border-bottom-color', 'red');
            }
            sectionData['title'] = $('#titleView-' + sectionId).val();
            sectionData['title_delta_format'] = $('#titleDeltaInput-' + sectionId).val();
            sectionData['guidance'] = $('#guidanceView-' + sectionId).val();
            if ($('#compactReport-'+sectionId).length) {
                sectionData['in_compact_report'] = $('#compactReport-'+sectionId).prop('checked');
            }
            allFormData.push(sectionData);
        });

        ajaxCall('post', '/admin/sections/save', allFormData)
            .done( function(data){
                let tabId = $('ul.tabs.headerTabs').find('.active').data('sectionId');
                location.replace('/admin/assessments/versions/' + versionId + '#headerSection-' + tabId);
                location.reload();
            })
            .fail(function(jqXHR){
                errorRoutine(jqXHR);
            });
    });

    $('button[id^="addQuestion-"]').click(function(){
        const versionId = $(this).data('versionId');
        const sectionData = {};
        const parentSectionId = $(this).data('parentSection');
        sectionData['title'] = $('#newQuestionTitle-'+parentSectionId).val() ?  $('#newQuestionTitle-'+parentSectionId).val() : "null";
        sectionData['guidance'] = $('#newQuestionGuidance-'+parentSectionId).val() ?  $('#newQuestionGuidance-'+parentSectionId).val() : "";
        sectionData['parent_id'] = parentSectionId;
        sectionData['isQuestion'] = true;

        let allFormData = [];
        $('form[id^="section-"]').each(function(index){
            const sectionId = $(this).data('section');
            let sectionData = {};
            sectionData['id'] = sectionId;
            if (!$('#titleView-'+sectionId).val()) {
                $('#titleView-'+sectionId).css('border-bottom-color', 'red');
            } else {
                sectionData['title'] = $('#titleView-'+sectionId).val();
                sectionData['guidance'] = $('#guidanceView-'+sectionId).val();
                if ($('#compactReport-'+sectionId).length) {
                    sectionData['in_compact_report'] = $('#compactReport-'+sectionId).prop('checked');
                }
                allFormData.push(sectionData);
            }
        });

        ajaxCall('post', '/admin/sections/save', allFormData)
            .fail(function(jqXHR){
                errorRoutine(jqXHR);
            });

        ajaxCall('post', '/admin/sections/add', sectionData)
            .done( function(data){
                let tabId = $('ul.tabs.headerTabs').find('.active').data('sectionId');
                location.replace('/admin/assessments/versions/' + versionId + '#headerSection-' + tabId);
                location.reload();
            })
            .fail( function(jqXHR){
                errorRoutine(jqXHR);
            });
    });

    $('button[id^="addSubsection-"]').click(function(){
        const versionId = $(this).data('versionId');
        const sectionData = {};
        const parentSectionId = $(this).data('parentSection');
        sectionData['title'] = $('#newSubsectionTitle-'+parentSectionId).val() ?  $('#newSubsectionTitle-'+parentSectionId).val() : "null";
        sectionData['guidance'] = $('#newSubsectionGuidance-'+parentSectionId).val() ?  $('#newSubsectionGuidance-'+parentSectionId).val() : "";
        sectionData['parent_id'] = parentSectionId;
        sectionData['isQuestion'] = false;

        ajaxCall('post', '/admin/sections/add', sectionData)
            .done( function(data){
                let tabId = $('ul.tabs.headerTabs').find('.active').data('sectionId');
                location.replace('/admin/assessments/versions/' + versionId + '#headerSection-' + tabId);
                location.reload();
            })
            .fail( function(jqXHR) {
                errorRoutine(jqXHR);
            });
    });
}

function ajaxCall(type, url, data){
    return $.ajax({
        type: type,
        url: url,
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        processData: true
    });
}

function errorRoutine(jqXHR){
    if(jqXHR.responseJSON == null){
        console.log(jqXHR.responseText);
    }else{
        console.log(jqXHR.responseJSON.message);
    }
}